/* This is how a normal module looks like. You can copy paste this
 * for any new module you want to create. Then you can import it in
 * main.js and call "init()" to execute the code.
 */
import vars from '../../../../vars.js';

const { jakte } = window;

function init() {
  if ( vars.slug == null) {
    console.warn('Jakte cannot be initialised if slug is absent from vars.js');
    return;
  }

  // eslint-disable-next-line
  const isStaging = process.env.APP_ENV === 'staging';

  jakte.Jakte.init({
    id: vars.slug,
    source: vars.source,
    plugins: [
      [
        jakte.JaktePluginNetwork,
        { url: isStaging 
          ? 'https://jakte.staging-drawbotics.com/api/v1/sessions'
          : 'https://jakte.drawbotics.com/api/v1/sessions'
        },
      ],
      [
        jakte.JaktePluginLeads,
        { url: isStaging
          ? 'https://crm.staging-drawbotics.com/public/v1/leads'
          : 'https://crm.drawbotics.com/public/v1/leads'
        },
      ],
      [jakte.JaktePluginUserAgent],
      [jakte.JaktePluginReferrer],
    ]
  });
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./src/static/js/modules/jakte.js